import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { UserDetails } from "~/modules/user/models/UserDetails.interface";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useGetUser({
  businessUnitCode,
  organizationCode,
}: GenericParameters) {
  let service = userAdministrationService.getSuperAdministrationUser.bind(
    userAdministrationService,
  );

  if (organizationCode) {
    service = userAdministrationService.getOrganizationUser.bind(
      userAdministrationService,
    );
  } else if (businessUnitCode) {
    service = userAdministrationService.getBusinessUnitUser.bind(
      userAdministrationService,
    );
  }
  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | undefined>();
  const result: Ref<UserDetails | undefined> = ref<UserDetails | undefined>(
    undefined,
  );

  async function getUser(userLogin: string): Promise<void> {
    isLoading.value = true;

    error.value = undefined;
    result.value = undefined;

    const response = await service({
      businessUnitCode,
      organizationCode,
      userLogin,
    });

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getUser,
    error,
    isLoading,
    result,
  };
}
